import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Les balises SEO du template (sans data-rh) sont retirées : react-helmet-async les gère et il ne doit
// en exister qu'une seule de chaque type (title, description, og:*, twitter:*, canonical, robots).
const MANAGED = 'title, meta[name="description"], meta[property^="og:"], meta[name^="twitter:"], link[rel="canonical"], meta[name="robots"], script[type="application/ld+json"]';
document.head.querySelectorAll(MANAGED).forEach(el => { if (!el.hasAttribute("data-rh")) el.remove(); });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
